(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  // ADD CLASS IS-HOMEPAGE TO HOMEPAGE
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      var path = (window.location.pathname || '').toLowerCase();
      var href = (window.location.href || '').toLowerCase();
      const marquee = document.querySelector('.marquee-custom');

      var isHome = path === '/' || path === '/index' || path === '' || path === '/chamello.store';
     // var containsAbout = path.includes('/about-us') || href.includes('about-us');
      var cartPage = path.includes('/cart') || href.includes('cart');
      var designSelectionPage = path.includes('/design-your-jacket') || href.includes('design-your-jacket');

      var mainContent = document.getElementById('MainContent');
      var firstShopifySection = mainContent
        ? mainContent.querySelector('.shopify-section')
        : document.querySelector('.shopify-section');

    //  if (isHome || containsAbout) {
      // if (isHome) {
      //   document.body.classList.add('transparent-header');
      //   if (firstShopifySection) firstShopifySection.style.marginTop = '';
      // } else {
      //   document.body.classList.remove('transparent-header');
      //   if (firstShopifySection) firstShopifySection.style.marginTop = '155px'; // adjust to your header height
      // }


      if (cartPage){
         document.body.classList.add('cart-page-custom');
      }

      if(designSelectionPage){
        document.body.classList.add('design-selection-page');
        document.documentElement.classList.add('design-selection-page');
      }

      if (isHome) {
        document.body.classList.add('transparent-header', 'home-page');
        document.documentElement.classList.add('transparent-header', 'home-page');
        if (firstShopifySection) firstShopifySection.style.marginTop = '';
        if (marquee) {
          marquee.style.display = 'block'; // or 'flex' depending on your layout
        }
      } else {
        document.body.classList.remove('transparent-header');
        if (firstShopifySection) {
          if (window.innerWidth < 992) {
            // firstShopifySection.style.marginTop = '81px';   // mobile
            firstShopifySection.style.marginTop = '73px';
          } else {
            firstShopifySection.style.marginTop = '129px';  // desktop
           // firstShopifySection.style.marginTop = '155px';  // desktop
          }
        } 
         // Hide marquee on all other pages
        const marquee = document.querySelector('.marquee-custom');
        if (marquee) {
          marquee.style.display = 'none';
        }
      }
    });
  })();


  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Add desktop menu toggle functionality when drawer icon is clicked
      this.setupDesktopMenuToggle();

      this.createObserver();
    }

    setupDesktopMenuToggle() {
      // Find the header drawer button and elements
      const headerDrawer = this.querySelector('header-drawer');
      const menuButton = headerDrawer ? headerDrawer.querySelector('.header__icon--menu') : null;
      const inlineMenu = this.querySelector('.header__inline-menu');
      
      if (menuButton && inlineMenu && headerDrawer) {
        // Prevent default drawer behavior on desktop when scrolled
        menuButton.addEventListener('click', (e) => {
          if (window.innerWidth >= 990 && this.headerWrapper.classList.contains('scrolled')) {
            e.preventDefault();
            e.stopPropagation();
            
            // Toggle menu
            const isOpen = inlineMenu.classList.contains('menu-open');
            
            if (isOpen) {
              inlineMenu.classList.remove('menu-open');
              headerDrawer.classList.remove('menu-is-open');
              menuButton.setAttribute('aria-expanded', 'false');
            } else {
              inlineMenu.classList.add('menu-open');
              headerDrawer.classList.add('menu-is-open');
              menuButton.setAttribute('aria-expanded', 'false'); // Keep it false to prevent overlay
            }
            
            // Prevent drawer from opening
            const details = headerDrawer.querySelector('details');
            if (details) {
              setTimeout(() => {
                details.removeAttribute('open');
              }, 0);
            }
            
            return false;
          }
        });

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
          if (window.innerWidth >= 990 && 
              this.headerWrapper.classList.contains('scrolled') &&
              !e.target.closest('.header__inline-menu') && 
              !e.target.closest('header-drawer') &&
              inlineMenu.classList.contains('menu-open')) {
            inlineMenu.classList.remove('menu-open');
            headerDrawer.classList.remove('menu-is-open');
            if (menuButton) {
              menuButton.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Check if page has transparent header
      const isTransparentHeader = document.body.classList.contains('transparent-header');

      // Add 'scrolled' class when scrolled past 100px
      if (scrollTop > 150) {
        this.headerWrapper.classList.add('scrolled');
      } else {
        this.headerWrapper.classList.remove('scrolled');
        // Close menu when back to top
        const inlineMenu = this.querySelector('.header__inline-menu');
        const headerDrawer = this.querySelector('header-drawer');
        if (inlineMenu && inlineMenu.classList.contains('menu-open')) {
          inlineMenu.classList.remove('menu-open');
        }
        if (headerDrawer && headerDrawer.classList.contains('menu-is-open')) {
          headerDrawer.classList.remove('menu-is-open');
        }
      }

      // Only run hide/reveal logic for transparent header pages
      if (!isTransparentHeader) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Original hide/reveal logic for transparent header pages
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
